

document.addEventListener('page:loaded', function() {
  console.log('page:loaded');
  (function(){
    // Reset dimensions on resize
    var responsiveSliders = document.querySelectorAll('[data-watchCSS="true"]');
    window.addEventListener('resize', function() {
      watchCSS();
    });

    function watchCSS(){
      responsiveSliders.forEach(function(element){
        //console.log(element);
        var afterContent = getComputedStyle( element, ':after' ).content;
        console.log(afterContent);
        // activate if :after { content: 'flickity' }
        var flkty = Flickity.data(element);
        //console.log('flkty', flkty);
        if ( afterContent.indexOf('flickity') != -1 ) {
          if (element.classList.contains('flickity-enabled')) {
         
            return;
          }
          element.setAttribute("data-flickity", '{"adaptiveHeight": true}');
          var newFlkty = new Flickity(element, JSON.parse(element.getAttribute('data-flickity')));
          console.log(newFlkty);
        } else {
          if (flkty) {
            flkty.destroy()
          }
        }
      })
    };
    watchCSS();


  })();
});
